let USER = JSON.parse(localStorage.getItem('INX.USER'));
let TOKEN = localStorage.getItem('INX.TOKEN');

export default {
    namespaced: true,
    state: {
        user: USER === null ? { empNO: '', ad: '', userID: '', name: '', role: 'user' } : USER,
        token: TOKEN ? TOKEN : '',
    },
    actions: {},
    getters: {
        EmpNo: state => {
            if (!state.user.empNo) {
                try {
                    const user = localStorage.getItem('INX.2FA.USER');
                    state.user = JSON.parse(user);
                } catch (e) {
                    console.error(e);
                }
            }
            return state.user.empNO;
        },
        AD: state => {
            if (!state.user.ad) {
                try {
                    const user = localStorage.getItem('INX.2FA.USER');
                    state.user = JSON.parse(user);
                } catch (e) {
                    console.error(e);
                }
            }
            return state.user.ad;
        },
        UserID: state => {
            if (!state.user.userID) {
                try {
                    const user = localStorage.getItem('INX.2FA.USER');
                    state.user = JSON.parse(user);
                } catch (e) {
                    console.error(e);
                }
            }
            return state.user.userID;
        },
        UserName: state => {
            if (!state.user.name) {
                try {
                    const user = localStorage.getItem('INX.2FA.USER');
                    state.user = JSON.parse(user);
                } catch (e) {
                    console.error(e);
                }
            }
            return state.user.name;
        },
        // MyApps: state => {
        // if (!state.user) {
        // try {
        // const user = localStorage.getItem('INX.USER');
        // state.user = JSON.parse(user);
        // } catch (e) {
        // console.error(e);
        // }
        // }
        // return state.user.apps;
        // },
        Role: state => {
            if (!state.user) {
                try {
                    const user = localStorage.getItem('INX.2FA.USER');
                    state.user = JSON.parse(user);
                } catch (e) {
                    console.error(e);
                }
            }
            return state.user.role;
        },
        // SecretKey: state => {
        // if (!state.secret_key) {
        // try {
        // const user = localStorage.getItem('INX.USER');
        // state.user = JSON.parse(user);
        // } catch (e) {
        // console.error(e);
        // }
        // }
        // return state.user.secret_key;
        // },
        Token: state => {
            if (!state.token) {
                try {
                    const token = localStorage.getItem('INX.2FA.TOKEN');
                    state.token = JSON.parse(token);
                } catch (e) {
                    console.error(e);
                }
            }
            return state.token;
        },
    },
    mutations: {
        setUser(state, user) {
            state.user = user;
            localStorage.setItem('INX.2FA.USER', JSON.stringify(user));
        },
        setToken(state, token) {
            state.token = token;
            localStorage.setItem('INX.2FA.TOKEN', token);
        },
        removeAllState(state) {
            state.user = {
                empNO: '',
                userID: '',
                name: '',
                apps: [],
                role: 'user',
            };
            state.token = '';
        },
        removeAllStorage() {
            localStorage.clear();
        },
    },
};
